<template>
  <div class="share-by-img">
    <div class="share-warp">
      <ul id="shareImgSwarp">
        <li v-for="(item, index) in shareImgs" :key="index">
          <img :src="item" alt="分享" />
        </li>
      </ul>
    </div>
    <ul class="share-indicator">
      <li v-for="(item, index) in shareImgs" :key="index" :class="{ active: currentIndex === index }"></li>
    </ul>
    <div class="share-tip" v-show="!getIsApp">长按图片发送给好友</div>
    <div :class="getIsApp ? 'share-tip' : 'share-bottm'" v-if="shareType !== 'goods'">
      <span>好友注册后你将获得 {{ recommendCards }} 张免单卡<br />好友也获得 1 张免单卡</span>
    </div>
    <div class="appSharePart" v-if="getIsApp">
      <div class="item tapActive" v-for="(item, index) in options" :key="index" @click="onShareTypeSelect(item)">
        <div class="iconBox">
          <img :src="item.icon" alt="" class="iconPic" />
        </div>
        <div class="text" v-text="item.name"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { GetShareImage, GetShareGoodsImage, RecommendQRCodeFrontEndConvertLink, RecommendProductFrontEndConvertLink } from '@/api/share'
import { GetRecommendSendQty } from '@/api/my'
import { Toast, Indicator } from 'mint-ui'
import StackingScroll from './children/stackingScroll'

export default {
  data() {
    return {
      shareImgs: [],
      shareType: '',
      productId: '',
      recommendCards: 0,
      stackingScroll: null,
      /**
      分享图片记录数据埋点:
        商品页 = 10
        全部订单 = 11
        购买完成 = 12
        邀请好友 = 13
        合伙人页面 = 14
       */
      pageType: 10,
      currentIndex: 0,
      options: [
        {
          name: '微信',
          icon: require('@/assets/image/icon-weixin.png'),
          scene: 'WXSceneSession',
          type: 2
        },
        {
          name: '朋友圈',
          icon: require('@/assets/image/icon-pengyouquan.png'),
          scene: 'WXSenceTimeline',
          type: 2
        },
        {
          name: '保存到相册',
          icon: require('@/assets/image/icon-xiangce.png'),
          scene: 'savePic',
          type: 2
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['getIsApp'])
  },
  mounted() {
    let shareSrc = this.$route.query.shareSrc
    if (shareSrc) {
      this.shareImgs = [shareSrc]
      this.shareType = 'goods'
      return
    }
    Indicator.open({
      text: '加载中',
      spinnerType: 'triple-bounce'
    })
    this.shareType = this.$route.query.type
    this.productId = this.$route.query.productId
    this.pageType = this.$route.query.pageType || 10
    this.getShareImg(this.shareType, this.productId, this.pageType)
  },
  methods: {
    // // 图片加载完成
    // imgLoad () {
    //   Indicator.close()
    //   Toast('长按图片即可发送给好友')
    // },
    // convertImageToBase64(url) {
    //   return new Promise((resolve, reject) => {
    //     const xhr = new XMLHttpRequest()
    //     xhr.onload = function() {
    //       const reader = new FileReader()
    //       reader.onloadend = function() {
    //         resolve(reader.result)
    //       }
    //       reader.onerror = reject
    //       reader.readAsDataURL(xhr.response)
    //     }
    //     xhr.onerror = reject
    //     xhr.open('GET', url)
    //     xhr.responseType = 'blob'
    //     xhr.send()
    //   })
    // },
    resHandler(res) {
      let { ImgUrls, IsFrontEndConvertLink } = res.Data
      if (IsFrontEndConvertLink) {
        if (this.shareType === 'goods' && this.productId) {
          this.RecommendProductFrontEndConvertLink({ tempData: res.Data })
        } else {
          this.RecommendQRCodeFrontEndConvertLink({ tempData: res.Data })
        }
        return
      }
      // ImgUrls = ImgUrls.replaceAll(/http:/g, 'https:')
      if (this.shareType === 'goods' && this.productId) {
        this.shareImgs = [ImgUrls]
        Indicator.close()
      } else {
        this.shareImgs = ImgUrls.split(',')
        let loop = true
        if (this.shareImgs.length <= 2) loop = false
        else loop = true
        this.$nextTick(() => {
          let _this = this
          this.stackingScroll = new StackingScroll({
            selector: '#shareImgSwarp',
            loop: loop,
            itemScale: ['scale3d(.8, .92, 1)', 'scale3d(.8, .92, 1)', 'scale3d(.667, .667, 1)', 'scale3d(.667, .667, 1)'],
            itemTranslates: ['-69vw', '69vw', '-140vw', '140vw'],
            itemChange: function(index) {
              _this.currentIndex = index
            }
          })
          Indicator.close()
        })
      }
    },
    // 转码图片分享接口(商品分享接口)
    async RecommendProductFrontEndConvertLink({ tempData = {} }) {
      const { ProductFrontEndConvertLink } = tempData
      const base64 = await this.$utils.convertImageToBase64(ProductFrontEndConvertLink.ProductPic)
      ProductFrontEndConvertLink.ProductPic = base64
      RecommendProductFrontEndConvertLink({
        ...ProductFrontEndConvertLink
      }).then((res) => {
        this.resHandler(res)
      })
    },
    // 转码图片分享接口（邀请好友等）
    async RecommendQRCodeFrontEndConvertLink({ tempData = {} }) {
      const { NeedConvertLinkList } = tempData
      for (const item of NeedConvertLinkList) {
        const base64 = await this.$utils.convertImageToBase64(item.ShowPicUrl)
        item.ShowPicUrl = base64
      }
      RecommendQRCodeFrontEndConvertLink({
        pageType: this.pageType,
        needConvertLinkList: NeedConvertLinkList
      }).then((res) => {
        this.resHandler(res)
      })
    },
    getShareImg(shareType, productId, pageType) {
      if (shareType === 'goods' && productId) {
        let params = {
          ProductId: productId,
          pageType: parseInt(pageType)
        }
        GetShareGoodsImage(params)
          .then((res) => {
            this.resHandler(res)
          })
          .catch((res) => {
            Indicator.close()
            if (res.ErrMsg) {
              Toast(res.ErrMsg)
            }
          })
      } else {
        GetShareImage({ pageType: parseInt(pageType) })
          .then((res) => {
            this.resHandler(res)
          })
          .catch((res) => {
            Indicator.close()
            if (res.ErrMsg) {
              Toast(res.ErrMsg)
            }
          })
        this.fetchRecommendCards()
      }
    },
    // 获取邀请好友赠送的免单卡数
    fetchRecommendCards() {
      GetRecommendSendQty().then((res) => {
        this.recommendCards = res.Msg
      })
    },
    onShareTypeSelect(option) {
      option.imageUrl = this.shareImgs[this.currentIndex]
      this.$uni.postMessage({
        data: {
          shareMessage: option
        }
      })
    }
  }
}
</script>

<style lang="scss">
.share-by-img {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  height: 100vh;
  background: #f2f2f2;
  overflow-x: hidden;
  box-sizing: border-box;
}
.share-warp {
  height: 65vh;
  width: 100%;
  margin-top: 3vh;
}
.share-warp > ul {
  position: relative;
  height: 100%;
  width: 68%;
  margin-left: 50%;
  transform: translate3d(-50%, 0, 0);
}
.share-warp > ul > li {
  display: flex;
  align-items: center;
  justify-content: space-around;
  position: absolute;
  height: 100%;
  width: 100%;
  border-radius: 5px;
  text-align: center;
}
.share-warp img {
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100%;
  pointer-events: auto;
  border-radius: 5px;
}
.share-indicator {
  height: 15px;
  line-height: 15px;
  text-align: center;
  margin-top: 10px;
}
.share-indicator li {
  display: inline-block;
  margin-left: 8px;
  height: 8px;
  width: 8px;
  border-radius: 50%;
  background: #cecece;
  transition: all 0.3s ease-in;
}
.share-indicator li:first-child {
  margin-left: 0px;
}
.share-indicator li.active {
  background: #8a8a8a;
}
.share-tip {
  margin-top: 10px;
  color: #666;
  font-size: 15px;
  text-align: center;
}
.share-bottm {
  position: fixed;
  bottom: 2vh;
  color: #666;
  text-align: center;
  width: 100%;
  font-size: 15px;
}
@media screen and (min-height: 737px) {
  .share-warp {
    height: 62vh;
  }
}
.appSharePart {
  // position: fixed;
  // bottom: 4vh;
  display: flex;
  align-items: center;
  width: 100%;
  margin-top: 20px;
  margin-bottom: 20px;
  .item {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1;
    .iconBox {
      display: flex;
      align-items: center;
      justify-content: space-around;
      width: 60px;
      height: 60px;
      // background-color: pink;
      font-size: 60px;
      .iconPic {
        width: 44px;
      }
    }
    .text {
      font-size: 14px;
      color: #4e5256;
    }
  }
}
</style>
